module.exports = __webpack_public_path__ + "img/musical_instrument.54bda6eb.svg";